<template>
    <div class="MainScreen">
        <header class="header">
            <h1>iO</h1>
        </header>
        <LoadingSpinner v-if="isLoading" />
        <div class="content">
            <div class="upload-form">
                <main class="main-content">
                    <!-- Webcam Video Preview -->
                    <video ref="webcamVideo" autoplay class="webcam-preview"></video>
                    <button @click="captureImage" class="button-primary">Bild aufnehmen</button>
                </main>
            </div>
            <div class="saved-foods">
                <h2>Gespeicherte Lebensmittel:</h2>
                <ul v-if="foodData && foodData.length" class="food-list">
                    <li v-for="(food, index) in foodData" :key="index" class="food-item">
                        <img :src="getIconForFood(food.name)" alt="icon" class="food-icon" />
                        <span class="food-name">{{ food.name }}</span>
                        <span class="food-quantity">{{ food.quantity }}</span>
                    </li>
                </ul>
                <p v-else>Keine Daten vorhanden.</p>
            </div>
        </div>

        <div v-if="showModal" class="modal">
            <div class="modal-content">
                <h2>Erkannte Daten</h2>

                <!-- Lebensmittel und Gewichte nach Position anzeigen -->
                <div v-for="(position, key) in ['a', 'b', 'c']" :key="key">
                    <h3 v-if="getRecognizedDataByPosition(position).length > 0">
                        {{ getPositionLabel(position) }}
                    </h3>
                    <ul v-if="getRecognizedDataByPosition(position).length > 0">
                        <li v-for="(item, index) in getRecognizedDataByPosition(position)" :key="index">
                            <img :src="getIconForFood(item.name)" alt="icon" class="food-icon" />
                            <span class="food-name">{{ item.name }}</span>
                            <div class="horizontal-container">
                                <button class="quantityButton" @click="item.quantity++">+</button>
                                <span class="food-quantity">{{ item.quantity }}</span>
                                <button class="quantityButton" @click="item.quantity--"
                                    :disabled="item.quantity == 0">-</button>
                            </div>
                            <span class="food-weight">Gewicht: {{ item.weight }} </span>
                        </li>
                    </ul>
                    <p v-else>
                        Keine Daten für {{ getPositionLabel(position) }} vorhanden.
                    </p>
                </div>
                <button class="confirmButton" @click="closeModal">Speichern</button>
            </div>
        </div>
    </div>
</template>
  
<script>
import OpenAI from "openai";
import { ref, get, set, getDatabase, onValue } from "firebase/database";
import { app as firebaseApp } from "../firebaseConfig";
import appleIcon from '../assets/icons/apple.svg'
import bananaIcon from '../assets/icons/banana.svg'
import butterIcon from '../assets/icons/butter.svg'
import kiwiIcon from '../assets/icons/kiwi.svg'
import melonIcon from '../assets/icons/melon.svg'
import onionIcon from '../assets/icons/onion.svg'
import pastaIcon from '../assets/icons/pasta.svg'
import tomatocanIcon from '../assets/icons/tomatocan.svg'
import pearIcon from '../assets/icons/pear.svg'
import lemonIcon from '../assets/icons/lemon.svg'
import milkIcon from '../assets/icons/milk.svg'
import LoadingSpinner from './LoadingSpinner.vue';
import wheatIcon from '../assets/icons/wheat.png'
import tomatoIcon from '../assets/icons/tomato.svg'
export default {
    name: 'UploadForm',
    components: {
        LoadingSpinner // Ladeanimation-Komponente registrieren
    },
    data() {
        return {
            selectedFile: null,
            previewImage: null,
            timestamp: new Date().toISOString(),
            foodData: [],
            weightsData: { a: { average: 0, timestamp: '' }, b: { average: 0, timestamp: '' }, c: { average: 0, timestamp: '' } },
            showModal: false,
            recognizedData: [],
            alreadyChanged: false,
            isLoading: false,
        };
    },
    mounted() {
        this.rtdb = getDatabase(firebaseApp);
        this.fetchFoodData();
        this.fetchWeightsData();
        this.startWebcam();
        const starCountRef = ref(this.rtdb, '/scans');
        onValue(starCountRef, () => {
            if (!this.alreadyChanged) {
                this.alreadyChanged = true;
                return;
            }
            this.captureImage();
        });
    },
    methods: {
        getIconForFood(foodName) {
            switch (foodName.toLowerCase()) {
                case 'apple':
                    return appleIcon;
                case 'banana':
                    return bananaIcon;
                case 'kiwi':
                    return kiwiIcon;
                case 'melon':
                    return melonIcon;
                case 'red onions':
                    return onionIcon;
                case 'yellow onions':
                    return onionIcon;
                case 'spelt pasta':
                    return pastaIcon;
                case 'canned tomatoes':
                    return tomatocanIcon;
                case 'canned pears':
                    return pearIcon;
                case 'lemon':
                    return lemonIcon;
                case 'butter':
                    return butterIcon;
                case 'milk':
                    return milkIcon;
                case 'chocolate milk':
                    return milkIcon;
                case 'pear':
                    return pearIcon;
                case 'flour':
                    return wheatIcon;
                case 'tomato':
                    return tomatoIcon;
                default:
                    return ''; // Oder ein Standard-Icon
            }
        },
        async startWebcam() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.webcamVideo.srcObject = stream;
            } catch (error) {
                console.error('Webcam konnte nicht gestartet werden:', error);
            }
        },
        captureImage() {
            const video = this.$refs.webcamVideo;
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            this.previewImage = canvas.toDataURL('image/jpeg');
            this.selectedFile = this.dataURLtoFile(this.previewImage, 'webcam-image.jpg');
            this.uploadImage();
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },

        onFileChange(event) {
            this.selectedFile = event.target.files[0];
            // Vorschau anzeigen
            if (this.selectedFile) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImage = e.target.result;
                };
                reader.readAsDataURL(this.selectedFile);
            }
        },
        async uploadImage() {
            this.isLoading = true;
            if (!this.selectedFile) {
                alert("Bitte wähle eine Datei aus.");
                return;
            }

            const openai = new OpenAI({
                apiKey: process.env.VUE_APP_FABI_OPENAI_API_KEY,
                dangerouslyAllowBrowser: true
            });

            try {
                // Holen der Base64-Daten des Bildes
                const imageDataUrl = await this.getFileData(this.selectedFile);
                const base64Image = imageDataUrl.split(',')[1];

                // Liste der gespeicherten Lebensmittel aus der Datenbank laden
                const foodNames = this.foodData.map(food => food.name).join(', ');

                // Gewichtsdaten in ein lesbares Format umwandeln
                const weights = `bottom left (a): ${this.weightsData.a.average}, bottom right (b): ${this.weightsData.b.average}, top (c): ${this.weightsData.c.average}`;

                // Anfrage an OpenAI API vorbereiten
                const response = await openai.chat.completions.create({
                    model: "gpt-4o",
                    messages: [
                        {
                            role: "user",
                            content: [
                                {
                                    type: "text",
                                    text: `Here is a list of foods you should recognize: ${foodNames}. The current weights are: ${weights}. How many pieces of which food are in this picture and where are they located? Please respond in a JSON formed like this [{name: name, quantity: quantity, position: position, timestamp: timestamp}]. The image is available at:`
                                },
                                {
                                    type: "image_url",
                                    image_url: {
                                        url: "data:image/jpeg;base64," + base64Image
                                    }
                                }
                            ]
                        }
                    ],
                    max_tokens: 300,
                    temperature: 0.7
                });

                // Extrahiere den Inhalt der Nachricht aus der API-Antwort
                let messageContent = response.choices[0].message.content;

                // Bereinige die JSON-Antwort, um sie parsebar zu machen
                messageContent = messageContent.trim();
                messageContent = messageContent.replace(/```json/g, '');
                messageContent = messageContent.replace(/```/g, '');

                // Jetzt parse die bereinigte JSON-Zeichenfolge
                const resultData = JSON.parse(messageContent);
                this.isLoading = false;
                // Überprüfe, ob die extrahierten Daten ein Array sind
                if (Array.isArray(resultData)) {
                    // Transformiere die Positionen in recognizedData
                    this.recognizedData = resultData.map(item => {
                        const positionKey = this.getPositionKey(item.position);
                        return {
                            ...item,
                            weight: this.weightsData[positionKey]?.average || 0, // Übernehme das richtige Gewicht aus weightsData
                            position: positionKey // Speichern Sie die transformierte Position
                        };
                    });
                    console.log("Parsed recognizedData with updated positions:", this.recognizedData);
                    this.showModal = true; // Zeige das Modal nach dem Speichern der Daten
                    // Aktualisiere die Datenanzeige
                    this.fetchFoodData();
                } else {
                    console.error("Erwartetes Array, aber erhalten:", resultData);
                }

            } catch (error) {
                console.error("Es gab einen Fehler bei der Verarbeitung der Antwort:", error);
            }
        },
        async saveRecognizedData(food) {
            const recognizedDataRef = ref(this.rtdb, 'recognized_data/' + food.name);
            await set(recognizedDataRef, null);
            const dataToSave = {
                quantity: food.quantity,
                position: food.position,
                timestamp: this.timestamp
            };
            await set(recognizedDataRef, dataToSave);
        },
        getFileData(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        fetchFoodData() {
            const foodDataRef = ref(this.rtdb, 'food_data/');
            onValue(foodDataRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    this.foodData = Object.keys(data).map(key => ({
                        name: key,
                        quantity: data[key].quantity
                    }));
                }
            });
        },
        fetchWeightsData() {
            const weightsRef = ref(this.rtdb, 'weights/');
            onValue(weightsRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    this.weightsData = data;
                }
            });
        },
        async closeModal() {
            for (const food of this.recognizedData) {
                if (food && food.name && food.quantity && food.position) {
                    const dataRef = ref(this.rtdb, 'food_data/' + food.name);

                    // Lade den aktuellen Bestand aus Firebase
                    const snapshot = await get(dataRef);
                    const currentData = snapshot.val();

                    if (currentData && currentData.quantity) {
                        // Subtrahiere die erkannte Menge vom aktuellen Bestand
                        const newQuantity = currentData.quantity - food.quantity;

                        const dataToSave = {
                            timestamp: this.timestamp,
                            quantity: newQuantity
                        };

                        // Speichere die aktualisierten Daten in der Firebase Realtime Database
                        await set(dataRef, dataToSave);

                        // Speichere die erkannten Daten in einer anderen Collection
                        await this.saveRecognizedData(food);
                    } else {
                        console.error("Kein aktueller Bestand für:", food.name);
                    }
                } else {
                    console.error("Ungültige Datenstruktur in einem der Array-Elemente:", food);
                }
            }
            this.recognizedData = [];
            this.showModal = !this.showModal;
        },
        getPositionLabel(position) {
            switch (position) {
                case 'a':
                    return 'Bottom Left (a)';
                case 'b':
                    return 'Bottom Right (b)';
                case 'c':
                    return 'Top (c)';
                default:
                    return position;
            }
        },
        getPositionKey(label) {
            switch (label) {
                case 'bottom left':
                    return 'a';
                case 'bottom right':
                    return 'b';
                case 'top':
                    return 'c';
                default:
                    return label;
            }
        },
        getRecognizedDataByPosition(position) {
            if (this.recognizedData.length == 0) {
                return [
                    {
                        name: "No data available",
                        quantity: 1,
                        weight: 100
                    }
                ];
            }
            console.log(this.recognizedData.filter(item => item.position === position) + " ");
            return this.recognizedData.filter(item => item.position === position);
        }
    },
    watch: {
        scan: {
            handler() {
                console.log(this.scan);
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.MainScreen {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.quantityButton {
    background-color: #408E51;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: 16px;
    border: none;
    cursor: pointer;
    margin-left: 0.5rem;

}

.horizontal-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header {
    background-color: #408E51;
    width: 100vw;
    text-align: center;
    color: white;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    margin-top: 2rem;
    width: 100vw;
}

.upload-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.upload-section {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.image-preview {
    max-width: 300px;
    max-height: 300px;
    margin-top: 1rem;
}

.button-primary {
    background-color: #408E51;
    color: white;
    padding: 2rem 6rem;
    border-radius: 8px;
    font-size: 24px;
    border: none;
    cursor: pointer;
    margin-top: 1rem;
}

.saved-foods {
    width: 600px;
}

.food-list {
    list-style-type: none;
    padding: 0;
}

.modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}


.modal-content {
    background-color: #fff;
    padding: 2rem;
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 100%;
    /* Maximale Breite des Modals */
    max-height: 80vh;
    /* Maximale Höhe des Modals, scrollbar bei Überschreitung */
    overflow-y: auto;
    /* Vertikale Scrollbar hinzufügen */
}

.modal-content h2 {
    font-size: 1.5rem;
    /* Größe des Titels anpassen */
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content h2 img {
    width: 48px;
    /* Standard-Icon-Größe */
    height: 48px;
    align-self: center;
}

.modal-content ul {
    list-style: none;
    padding: 0;
}

.modal-content ul li {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
}

.modal-content ul li img {
    width: 48px;
    /* Standard-Icon-Größe */
    height: 48px;
    margin-bottom: 0.5rem;
}

.modal-content ul li .food-name {
    text-align: center;
    margin: 1rem;
}

.modal-content ul li .food-quantity,
.modal-content ul li .food-weight {
    text-align: center;
    margin: 1rem;
    font-size: 1rem;
    /* Größe von Gewicht und Menge anpassen */
}

.modal-content ul li .food-weight::after {
    content: " g";
}


.close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    font-size: 1.5rem;
}

.food-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    background-color: #C6FFD2;
}

.food-icon {
    width: 48px;
    height: 48px;
}

.food-name {
    flex-grow: 1;
    text-align: center;
}

.food-quantity {
    text-align: right;
    min-width: 50px;
    /* Optional: ensure a minimum width for quantity span */
}

.confirmButton {
    background-color: #408E51;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: 16px;
    border: none;
    cursor: pointer;
    margin-top: 1rem;
}
</style>

